export enum PageIndexOptions {
  primary,
  all,
}
